import { memo } from 'react';
import { Stack, Text, Box, Flex, Image } from '@chakra-ui/react';

import aiIcon from '@/assets/icon/ai-icon.svg';
import { InterviewAnalysisResult } from '@/types/AnalysisResult';

interface InterviewQNAsSectionProps {
  analysisResult: InterviewAnalysisResult;
}

const InterviewQNAsSection = memo(({ analysisResult }: InterviewQNAsSectionProps) => {
  return (
    <Stack>
      <Text color="neutrals.900" fontSize="18px" fontWeight="semibold" mb="20px">
        Interview Q&As
      </Text>
      {analysisResult.contents.map((content, index) => (
        <Box key={index} mb="24px" pr="12px">
          <Text fontSize="16px" fontWeight="semibold" color="neutrals.800" mb="12px">
            Q{index + 1}: {content.question}
          </Text>
          <Text fontSize="16px" color="neutrals.700" mb="12px">
            <Text as="span" fontWeight="semibold">
              A:{' '}
            </Text>
            {content.answer}
          </Text>
          <Flex mb="12px">
            <Image src={aiIcon} w="20px" h="20px" alt="AI Icon" />
            <Box color="neutrals.900" fontSize="16px" fontWeight="semibold" ml="8px">
              AI Feedback
            </Box>
          </Flex>
          <Text fontSize="16px" color="neutrals.700" mb="24px">
            {content.feedback}
          </Text>
          {index < analysisResult.contents.length - 1 && (
            <Box borderBottom="1px solid" borderColor="neutrals.200" />
          )}
        </Box>
      ))}
    </Stack>
  );
});

InterviewQNAsSection.displayName = 'InterviewQNAsSection';

export default InterviewQNAsSection;
